import React from 'react';
import { PricingCard } from './PricingCard';
// Replicated offer section below testimonials — uses the same PricingCard with a different anchor id
export function FinalCTA() {
  return <div className="max-w-3xl mx-auto" data-id="element-55">
      <PricingCard idAttr="pricing-bottom" data-id="element-56" />
    </div>;
}